import React from 'react'
import clsx from 'clsx'
import styles from './styles.module.scss'

type SpinnerProps = {
    size?: number | string
    className?: string
}

export const Spinner = ({ size, className }: SpinnerProps) => (
    <div style={{ fontSize: size }} className={clsx(styles.spinner, className)}>
        {Array.from({ length: 12 }, (_, i) => (
            <div key={i} />
        ))}
    </div>
)
